// extracted by mini-css-extract-plugin
export default {"PricesContainer":"dnxhIvIV","PrimaryPricesContainer":"zdc0Fb1x","SecondaryPricesContainer":"_tsVm3Q7"};